<mat-toolbar color="primary" class="flex gap-4">
  @if (isAuthenticated()){
  <button class="mx-2 btn-create-issue" mat-raised-button color="accent" (click)="createIssue()">
    Create Issue
  </button>
  <button
    mat-raised-button
    class="btn-my-work flex-row-reverse"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="showMyWork = !showMyWork"
  >
    My Work
    <mat-icon class="material-symbols-rounded">keyboard_arrow_down</mat-icon>
  </button>
  @defer (when showMyWork) {
  <gcp-workspace-my-work-menu
    class="mx-2"
    [triggerOrigin]="trigger"
    [showMyWork]="showMyWork"
    (backdropClicked)="showMyWork = false"
  ></gcp-workspace-my-work-menu>
  } @defer (when showOrgSwitcher()) {
  <gcp-workspace-filter-organization-context
    class="mx-2"
  ></gcp-workspace-filter-organization-context>
  } }
  <gcp-workspace-search-bar></gcp-workspace-search-bar>
  <span class="flex-grow flex-shrink-1 flex-basis-auto"></span>
  @if (isAuthenticated() === false){
  <gcp-workspace-login></gcp-workspace-login>
  } @else if (isAuthenticated()){
  <button
    mat-icon-button
    class="notifications-bell"
    cdkOverlayOrigin
    #bellTrigger="cdkOverlayOrigin"
    matTooltip="Notifications"
    aria-label="Notifications"
    [matBadge]="notificationService.unreadCount()"
    [matBadgeHidden]="notificationService.unreadCount() === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    (click)="showNotifications = !showNotifications"
  >
    <mat-icon class="material-symbols-rounded">notifications</mat-icon>
  </button>
  @defer (when showNotifications) {
  <gcp-workspace-notifications-menu
    [triggerOrigin]="bellTrigger"
    [open]="showNotifications"
    (backdropClicked)="showNotifications = false"
  ></gcp-workspace-notifications-menu>
  }
  <gcp-workspace-user-profile-menu></gcp-workspace-user-profile-menu>
  }
</mat-toolbar>
